import {
  getUniquePlayerNumberfireIds,
  groupByPlayerNumberfireId,
} from "@/utils/headToHead";
import Selection from "./Selection";
import type { Maybe, OddsSelection } from "@/graphql/gql/graphql";
import styles from "./Markets.module.scss";

type MarketsProps = {
  title: string;
  odds: Maybe<OddsSelection>[];
};

export const LineBetMarkets = ({ title, odds }: MarketsProps) => {
  const groups = groupByPlayerNumberfireId(odds);
  const playerIdsCol1 = getUniquePlayerNumberfireIds(odds.slice(0, 3));
  const playerIdsCol2 = getUniquePlayerNumberfireIds(odds.slice(3, 6));

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>
        <div className={styles.col1}>
          {playerIdsCol1.map((playerId) => {
            const [odds] = groups[playerId] ?? [];
            return <Selection key={playerId} primaryOdds={odds} />;
          })}
        </div>
        <div className={styles.col2}>
          {playerIdsCol2.map((playerId) => {
            const [odds] = groups[playerId] ?? [];
            return <Selection key={playerId} primaryOdds={odds} />;
          })}
        </div>
      </div>
    </div>
  );
};

export const TotalBetMarkets = ({ title, odds }: MarketsProps) => {
  const groups = groupByPlayerNumberfireId(odds);
  const playerIdsCol1 = getUniquePlayerNumberfireIds(odds.slice(0, 6));
  const playerIdsCol2 = getUniquePlayerNumberfireIds(odds.slice(6, 12));

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>
        <div className={styles.col1}>
          {playerIdsCol1.map((playerId) => {
            const [over, under] = groups[playerId] ?? [];
            return (
              <Selection
                key={playerId}
                primaryOdds={over}
                secondaryOdds={under}
              />
            );
          })}
        </div>
        <div className={styles.col2}>
          {playerIdsCol2.map((playerId) => {
            const [over, under] = groups[playerId] ?? [];
            return (
              <Selection
                key={playerId}
                primaryOdds={over}
                secondaryOdds={under}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
